/** Helpers for in-memory mock services — keeps seed data readable while storing byte strings. */

export function mockBytesFromMb(mb: number): string {
  return String(Math.round(mb * 1024 * 1024));
}

export function mockBytesString(bytes: number): string {
  return String(bytes);
}

export function mockNormalizeFileSize(fileSize: string | number | undefined): string {
  if (fileSize == null) {
    return '0';
  }
  if (typeof fileSize === 'number') {
    return String(Math.max(0, Math.round(fileSize)));
  }

  const trimmed = fileSize.trim();
  if (/^\d+$/.test(trimmed)) {
    return trimmed;
  }

  const match = /^([\d.]+)\s*(bytes|kb|mb|gb)$/i.exec(trimmed);
  if (!match) {
    return trimmed;
  }

  const value = parseFloat(match[1]);
  const unit = match[2].toLowerCase();
  const multipliers: Record<string, number> = {
    bytes: 1,
    kb: 1024,
    mb: 1024 ** 2,
    gb: 1024 ** 3,
  };

  return String(Math.round(value * multipliers[unit]));
}

export function mockDaysAgo(now: Date, days: number): Date {
  return new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
}

export function mockHoursAgo(now: Date, hours: number): Date {
  return new Date(now.getTime() - hours * 60 * 60 * 1000);
}

export function mockMinutesAgo(now: Date, minutes: number): Date {
  return new Date(now.getTime() - minutes * 60 * 1000);
}
